export default class File{
    constructor(id, extension, url, name){
        this.id = id;
        this.extension = extension;
        this.url = url;
        this.name = name;

        this.type = getFileType(extension);
    }
}

function getFileType(extension){
    switch (extension.toLowerCase()) {
        case '.pdf':
            return 'pdf';
        case '.docx':
            return 'word'
        case '.png' || '.jpg' || '.jpeg':
            return 'image'
        default:
            return 'alt'
    }
}